import { DateTime } from "luxon";
import { isEmpty } from "lodash";
import {
  makeTime,
  mergeUniq,
  sameTimes,
  sameMonths,
  monthNameOrNum,
} from "../helpers";

const ruleMaker = (span) => {
  /**
   * @param {Object (<startTime: String, endTime: String>)}
   * @returns a rule object.
   */

  const start = DateTime.fromISO(span.startTime, { zone: "UTC" });
  const end = DateTime.fromISO(span.endTime, { zone: "UTC" });

  const startObj = start.toObject();
  const endObj = end.toObject();

  const monthDays = [...new Set([startObj.day, endObj.day])];
  const months = [...new Set([monthNameOrNum(startObj.month), monthNameOrNum(endObj.month)])];

  return {
    startTime: makeTime(start),
    endTime: makeTime(end),
    month_days: monthDays,
    week_days: [],
    months,
  };
};

export default (timeStamps) => {
  /**
   * @param {Array}  timeStamps an array of objects with dateTime ISO strings.
   * @returns {Array} an array of objects with rules spread across start and end times.
   */

  if (isEmpty(timeStamps)) return [];

  const firstRule = ruleMaker(timeStamps.shift());
  const rules = [firstRule];
  
  timeStamps.forEach((ts) => {
    const last = rules[rules.length - 1];
    const next = ruleMaker(ts);
    if (sameTimes(last, next) && sameMonths(last, next)) {
      rules[rules.length -1].month_days = mergeUniq(last.month_days, next.month_days);
    } else {
      rules.push(next);
    }
  });

  return rules;
};
